import { render, staticRenderFns } from "./restriktionen-badge.vue?vue&type=template&id=8adbf826&scoped=true"
import script from "./restriktionen-badge.vue?vue&type=script&lang=js"
export * from "./restriktionen-badge.vue?vue&type=script&lang=js"
import style0 from "./restriktionen-badge.vue?vue&type=style&index=0&id=8adbf826&prod&scoped=true&lang=css"
import style1 from "./restriktionen-badge.vue?vue&type=style&index=1&id=8adbf826&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8adbf826",
  null
  
)

export default component.exports